// 列尾〔⋯〕選單（SPEC #vms-web-787：角色不是表格裡的下拉，〔⋯〕›〔變更角色…〕）。點外面或 Esc 關閉。
import { useEffect, useRef, useState, type ReactNode } from 'react';

export interface MoreItem {
  key: string;
  label: ReactNode;
  onClick(): void;
  danger?: boolean;
  hidden?: boolean;
}

/** 跟 .ot-menu 的 min-width 一致 */
const MENU_MIN_W = 180;

export function MoreMenu({ label, items }: { label: string; items: MoreItem[] }) {
  const [open, setOpen] = useState(false);
  // 選單預設靠按鈕右緣往左展開；左邊放不下（會被側欄切掉，第二輪 B2-19）就改靠左緣往右展開
  const [alignLeft, setAlignLeft] = useState(false);
  const ref = useRef<HTMLSpanElement>(null);
  const toggle = () => {
    const r = ref.current?.getBoundingClientRect();
    const minLeft = ref.current?.closest('main')?.getBoundingClientRect().left ?? 0;
    setAlignLeft(!!r && r.right - MENU_MIN_W < minLeft + 8);
    setOpen((o) => !o);
  };
  useEffect(() => {
    if (!open) return;
    const off = (e: MouseEvent) => !ref.current?.contains(e.target as Node) && setOpen(false);
    const esc = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', off);
    document.addEventListener('keydown', esc);
    return () => {
      document.removeEventListener('mousedown', off);
      document.removeEventListener('keydown', esc);
    };
  }, [open]);
  const shown = items.filter((i) => !i.hidden);
  if (!shown.length) return null;
  return (
    <span className="ot-menu-wrap" ref={ref}>
      <button type="button" className="icon-btn" aria-label={label} aria-haspopup="menu" aria-expanded={open} onClick={toggle}>
        ⋯
      </button>
      {open && (
        <span className={'ot-menu' + (alignLeft ? ' ot-menu-left' : '')} role="menu">
          {shown.map((i) => (
            <button key={i.key} type="button" role="menuitem" className={i.danger ? 'danger' : undefined} onClick={() => (setOpen(false), i.onClick())}>
              {i.label}
            </button>
          ))}
        </span>
      )}
    </span>
  );
}
